import md5 from 'blueimp-md5'

export default file => new Promise((resolve) => {
	const reader = new FileReader()

	reader.onload = (e) => {
		const hash = md5(e.target.result)
		resolve(hash.toString())
	}

	reader.readAsBinaryString(file)
})
